import {
	DEL_WEBHOOK_FAIL,
	DEL_WEBHOOK_REQ,
	DEL_WEBHOOK_SUCCESS,
	GET_WEBHOOK_SETTINGS_FAIL,
	GET_WEBHOOK_SETTINGS_REQ,
	GET_WEBHOOK_SETTINGS_SUCCESS,
	SAVE_WEBHOOK_SETTINGS_FAIL,
	SAVE_WEBHOOK_SETTINGS_REQ,
	SAVE_WEBHOOK_SETTINGS_SUCCESS,
} from '../constants/settings';

export const webhookSettingsReducer = (
	state = { webhooks: [], page: 1, totalPage: 0 },
	action
) => {
	switch (action.type) {
		case GET_WEBHOOK_SETTINGS_REQ:
			return { loading: true };
		case GET_WEBHOOK_SETTINGS_SUCCESS:
			return {
				loading: false,
				webhooks: action.payload[0]?.data,
				page: action.payload[0]?.metadata[0]?.page,
				totalPage:
					action.payload[0]?.metadata[0]?.total %
						action.payload[0]?.metadata[0]?.limit ===
					0
						? action.payload[0]?.metadata[0]?.total /
						  action.payload[0]?.metadata[0]?.limit
						: parseInt(
								action.payload[0]?.metadata[0]?.total /
									action.payload[0]?.metadata[0]?.limit
						  ) + 1,
			};
		case GET_WEBHOOK_SETTINGS_FAIL:
			return { loading: false, error: action.payload };
		case SAVE_WEBHOOK_SETTINGS_REQ:
			return { ...state, loading: true };
		case SAVE_WEBHOOK_SETTINGS_SUCCESS:
			return {
				loading: false,
				success: true,
			};
		case SAVE_WEBHOOK_SETTINGS_FAIL:
			return { ...state, loading: false, error: action.payload };
		case DEL_WEBHOOK_REQ:
			return { ...state, loading: true };
		case DEL_WEBHOOK_SUCCESS:
			return {
				loading: false,
				successDelete: true,
			};
		case DEL_WEBHOOK_FAIL:
			return { ...state, loading: false, error: action.payload };
		default:
			return state;
	}
};
